module.exports = __webpack_public_path__ + "16_hair_brown.90d60425.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/16_hair_brown.png
// module id = UGEz
// module chunks = 0